import type { ChatMessage, ChatLinkAttachment, ChatLinkPreviewResult } from "../chat.types";

const URL_RE = /https?:\/\/[^\s<>'"]+/g;

export const resolveLinksForMessage = (
  msg: ChatMessage,
  linkPreview: ((url: string) => Promise<ChatLinkPreviewResult>) | undefined,
  cache: Map<string, boolean>,
): void => {
  if (typeof linkPreview !== "function" || !msg.msg) return;

  const urls = msg.msg.match(URL_RE);
  if (!urls) return;

  const existingUrls = new Set(
    (msg.attachments ?? []).filter((a): a is ChatLinkAttachment => a.type === "link").map((a) => a.url),
  );

  for (const url of urls) {
    if (cache.has(url) || existingUrls.has(url)) continue;
    cache.set(url, true);

    linkPreview(url)
      .then((result) => {
        if (!result) return;
        const attachment: ChatLinkAttachment = { type: "link", url, ...result };
        if (!msg.attachments) msg.attachments = [];
        msg.attachments.push(attachment);
      })
      .catch(() => {
        // Silently ignore failed previews
      });
  }
};

export const fileExt = (filename: string): string => {
  const dot = filename.lastIndexOf(".");
  return dot === -1 ? "?" : filename.slice(dot + 1);
};

export const formatSize = (bytes?: number): string => {
  if (bytes == null) return "";
  if (bytes < 1024) return bytes + " B";
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + " KB";
  return (bytes / (1024 * 1024)).toFixed(1) + " MB";
};

export const linkDomain = (url: string): string => {
  try {
    return new URL(url).hostname;
  } catch {
    return url;
  }
};
